import { IonButton, IonButtons, IonChip, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonModal, IonRow, IonTitle, IonToast, IonToolbar, useIonAlert } from '@ionic/react';
import { addCircle, arrowBackOutline, calendarOutline, locationOutline, removeCircle, syncOutline, ticketOutline, trash } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../contexts/MessageContext';
import useAnalytics from '../../../hooks/useAnalytics';
import { cadastrarELogarDireto, cashbackCarregar, requestService } from '../../../Utils/Services';
import PedidoFechar from '../../Cliente/Home/pages/OrdensFechar/OrdensFechar';
import Agendamento from '../Agendamento/Agendamento';
import Cashback from '../Cashback/Cashback';
import Cupom from '../Cupom/Cupom';
import Endereco from '../Endereco/Endereco';
import Entrar from '../Entrar/Entrar';
import './Carrinho.css';

type Props = {
  logado: any;
  closeAction: Function;
  closeActionVoltar: Function;
}

const Carrinho: React.FC<Props> = (props: Props) => {



  const history = useHistory<any>();

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);


  // Estados de modais e alertas
  const [mostrarAlerta] = useIonAlert();

  // Estados de dados e listas
  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [valorTotal, setValorTotal] = useState<any>();

  // State: Detalhes do Endereço
  const [showPedidoFechar, setShowPedidoFechar] = useState(false);
  const [showDetalhesEndereco, setShowDetalhesEndereco] = useState(false);
  const [showModalDesconto, setShowModalDesconto] = useState(false);
  const inputRefEndereco = useRef<any>(null);
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [complemento, setComplemento] = useState("");
  const [taxaEntrega, setTaxaEntrega] = useState<any>();
  const [tempoEntrega, setTempoEntrega] = useState<any>();
  const [desconto, setDesconto] = useState<any>();
  const [cupom, setCupom] = useState<any>();
  const [taxaServico, setTaxaServico] = useState<any>();

  const [showModalAgendamento, setShowModalAgendamento] = useState(false);
  const [tipoAgendamento, setTipoAgendamento] = useState("");
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const analytics = useAnalytics();

  // Analytics: AbandonCheckout — dispara 5min após inatividade com itens no carrinho
  useEffect(() => {
    if (!listaItemProdutos || listaItemProdutos.length === 0) return;
    const timer = setTimeout(() => {
      try {
        const totalNum = parseFloat(String(valorTotalProdutos || 0).replace(/\./g, '').replace(/\,/g, '.')) || 0;
        analytics.trackAbandonCheckout(listaItemProdutos, totalNum);
      } catch (e) { /* noop */ }
    }, 5 * 60 * 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaItemProdutos]);
  const [showModalCashBack, setShowModalCashBack] = useState(false);
  const [totalCashBack, setTotalCashBack] = useState(0);
  const [listCashBack, setListCashBack] = useState<any[]>([]);
  const [resgateCashBack, setResgateCashBack] = useState(0);
  const [showModalEntrar, setShowModalEntrar] = useState(false);

  async function carregarCashback(empresaid: string) {

    requestService(cashbackCarregar.url.replace("{id}", empresaid.replace(/#/g, '%23')), {
      method: cashbackCarregar.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log("Cashback carregado:", response);
        setTotalCashBack(response.totalCashback || 0);
        setListCashBack(response.items || []);
      },
      (error: any) => {
        console.error("Erro ao carregar cashback:", error);
      });
  }

  useEffect(() => {

    console.log("entrou carrinho");
    setEndereco(localStorage.getItem("enderecoEntrega") || "");
    setEnderecoLat(localStorage.getItem("latitudeEntrega") || "");
    setEnderecoLng(localStorage.getItem("longitudeEntrega") || "");
    setTaxaEntrega(localStorage.getItem("taxaEntrega") || "");
    setTempoEntrega(localStorage.getItem("tempoEntrega") || "");
    setComplemento(localStorage.getItem("complementoEntrega") || "");

    // setTipoAgendamento(localStorage.getItem("tipoAgendamento") || "");
    // setDataAgendamento(localStorage.getItem("dataAgendamento") || "");
    // setHoraAgendamento(localStorage.getItem("horaAgendamento") || "");

    carregarSomasItemProdutos();

    let empresaid = localStorage.getItem("empresaid") || "";
    if (dadosEmpresa?.pk) {
      empresaid = dadosEmpresa.pk;
    }
    if (dadosEmpresa?.cashbackAtivado && props.logado && empresaid) {
      carregarCashback(empresaid);
    }


  }, []);

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (desconto) {
        valorTotalRecalculado -= (descontoFloat ? descontoFloat : 0);
      }

      if (resgateCashBack) {
        valorTotalRecalculado -= (resgateCashBack ? resgateCashBack : 0);
      }

      if (taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [taxaEntrega, taxaServico, desconto, resgateCashBack, valorTotalProdutos]);

  // Cupom percentual: o desconto monetário depende da base (produtos ou total),
  // então recalcula quando o carrinho ou o frete muda. Cupom fixo mantém o valor.
  useEffect(() => {
    if (!cupom) return;
    const cfg = Array.isArray(dadosEmpresa?.configuracoesCupom)
      ? dadosEmpresa.configuracoesCupom.find((c: any) => c.nome === cupom)
      : null;
    if (!cfg) return;
    if ((cfg.tipoDesconto || 'fixo') !== 'percentual') return;

    const baseProdutos = parseFloat(String(valorTotalProdutos || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0;
    const baseEntrega = parseFloat(String(taxaEntrega || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0;
    const base = baseProdutos + ((cfg.baseDesconto === 'total') ? baseEntrega : 0);
    const pct = parseFloat(String(cfg.valor ?? '0').replace(/\,/g, '.')) || 0;
    const monetario = Math.round(base * pct) / 100;
    const novo = monetario.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    setDesconto((prev: any) => (prev === novo ? prev : novo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cupom, valorTotalProdutos, taxaEntrega]);

  const loadItemProdutos = () => {

    if (listaItemProdutos == undefined) return;

    if (listaItemProdutos.length === 0) {
      return (
        <>
          <IonItem lines="none">

            <IonLabel>
              <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum item adicionado</strong></h2>
            </IonLabel>

          </IonItem>
        </>

      );
    }

    return (
      <>
        <IonGrid>

          {listaItemProdutos.map((value: any, index: any) => (
            <>

              <IonRow style={{ borderColor: '#dddddd', borderWidth: '1px', borderBottomStyle: 'dashed' }}>


                <IonCol size="9">



                  {(value.descricao && Array.isArray(value.descricao)) ? (

                    <>
                      {(value.tipo === "pizzas") ? (
                        <div>{value.tamanho} {value.quantidadeSabores} SABORES</div>
                      ) : (
                        <div>{value.categoria}</div>
                      )}
                      {value.descricao.map((item: any, index: number) => (
                        <div key={"desc" + index}>
                          - {item.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {item.valor?.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}</IonLabel>)
                        </div>
                      ))}
                    </>

                  ) : (
                    <div key={"desc" + index}>
                      {value.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {value.valor?.toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}</IonLabel>)

                    </div>
                  )}



                </IonCol>


                <IonCol style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} sizeXs="3" >
                  <IonLabel style={{ textAlign: "right" }}>{value.subtotal}</IonLabel>
                </IonCol>
                <IonCol sizeSm='6'>
                  <IonLabel style={{ textAlign: "right", fontSize: "12px" }} >
                    <IonChip style={{ margin: 0, padding: '5px' }} disabled={false}>
                      <IonIcon size='large' color='danger' icon={removeCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata a quantidade atual
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        if (quantidadeFormatada > 1) {
                          // Decrementa a quantidade
                          let quantidadeNova = quantidadeFormatada - 1;

                          // Formata o valor e calcula o novo valor com base na nova quantidade
                          const valorFormatado = parseFloat(
                            itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );

                          // Atualiza a quantidade e o valor do item
                          itemToUpdate.quantidade = quantidadeNova;
                          const valorFloat = quantidadeNova * valorFormatado;

                          itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          });

                          // Substitui o item atualizado na lista copiada
                          updatedList[index] = itemToUpdate;

                          let totalValor = updatedList.reduce((total: any, item: any) => {
                            const itemValorNumerico = parseFloat(
                              item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                            );
                            return total + itemValorNumerico;
                          }, 0);

                          setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }));

                          // Atualiza o estado com a nova lista
                          setListaItemProdutos(updatedList);

                        }

                      }}></IonIcon>
                      <IonLabel style={{ fontSize: '20px' }}>{value.quantidade.toLocaleString('pt-br', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}</IonLabel>
                      <IonIcon size='large' color='success' icon={addCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata e incrementa a quantidade
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        let quantidadeNova = quantidadeFormatada + 1;

                        // let stockExceeded = false;
                        // let outOfStockMessage = "";

                        // // Calcula a demanda total de cada sub-item (por id) já presente no carrinho,
                        // // somando todos os itens exceto o atual (que usará quantidadeNova)
                        // const calcularSubQtd = (descricaoStr: string): number => {
                        //   const m = String(descricaoStr).match(/^(\d+)x\s/);
                        //   return m ? parseInt(m[1], 10) : 1;
                        // };

                        // const demandaOutrosItens: Record<string, number> = {};
                        // updatedList.forEach((otherItem: any, otherIndex: number) => {
                        //   if (otherIndex !== index && Array.isArray(otherItem.descricao)) {
                        //     const qtdOther = parseFloat(
                        //       otherItem.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        //     );
                        //     otherItem.descricao.forEach((otherSub: any) => {
                        //       if (otherSub.controlarEstoque && otherSub.id) {
                        //         const sq = calcularSubQtd(otherSub.descricao);
                        //         demandaOutrosItens[otherSub.id] = (demandaOutrosItens[otherSub.id] || 0) + sq * qtdOther;
                        //       }
                        //     });
                        //   }
                        // });

                        // if (itemToUpdate.descricao && Array.isArray(itemToUpdate.descricao)) {
                        //   for (const subItem of itemToUpdate.descricao) {
                        //     if (subItem.controlarEstoque) {
                        //       let subQtd = 1;
                        //       const match = String(subItem.descricao).match(/^(\d+)x\s/);
                        //       if (match) {
                        //         subQtd = parseInt(match[1], 10);
                        //       } else {
                        //         const matchPizza = String(subItem.descricao).match(/^1\/\d+\s/);
                        //         if (matchPizza) {
                        //           subQtd = 1;
                        //         }
                        //       }

                        //       const demandaOutros = subItem.id ? (demandaOutrosItens[subItem.id] || 0) : 0;
                        //       const totalSolicitado = subQtd * quantidadeNova + demandaOutros;
                        //       const availableStock = Number(subItem.quantidadeEstoque) || 0;

                        //       if (totalSolicitado > availableStock) {
                        //         stockExceeded = true;
                        //         outOfStockMessage = `O item "${subItem.descricao}" possui limite de ${availableStock} unidade(s).`;
                        //         break;
                        //       }
                        //     }
                        //   }
                        // } else if (itemToUpdate.controlarEstoque) {
                        //   // Fallback para itens simples sem descricao em array
                        //   const availableStock = Number(itemToUpdate.quantidadeEstoque) || 0;
                        //   let demandaOutros = 0;
                        //   if (itemToUpdate.id) {
                        //     updatedList.forEach((otherItem: any, otherIndex: number) => {
                        //       if (otherIndex !== index && !Array.isArray(otherItem.descricao) && otherItem.controlarEstoque && otherItem.id === itemToUpdate.id) {
                        //         const otherQty = parseFloat(
                        //           otherItem.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        //         );
                        //         demandaOutros += otherQty;
                        //       }
                        //     });
                        //   }
                        //   if (quantidadeNova + demandaOutros > availableStock) {
                        //     stockExceeded = true;
                        //     outOfStockMessage = `Este produto possui limite de ${availableStock} unidade(s).`;
                        //   }
                        // }

                        // if (stockExceeded) {
                        //   setTextToast(outOfStockMessage);
                        //   setShowToast(true);
                        //   return;
                        // }

                        // Formata o valor e calcula o novo valor com base na nova quantidade
                        const valorFormatado = parseFloat(
                          itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        // Atualiza a quantidade e o valor do item
                        itemToUpdate.quantidade = quantidadeNova;
                        const valorFloat = quantidadeNova * valorFormatado;

                        itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        });

                        // Substitui o item atualizado na lista copiada
                        updatedList[index] = itemToUpdate;

                        let totalValor = updatedList.reduce((total: any, item: any) => {
                          const itemValorNumerico = parseFloat(
                            item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );
                          return total + itemValorNumerico;
                        }, 0);

                        setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }));

                        // Atualiza o estado com a nova lista
                        setListaItemProdutos(updatedList);


                      }}></IonIcon>
                    </IonChip>
                  </IonLabel>
                </IonCol>
                <IonCol style={{ display: "flex", justifyContent: "flex-end" }} sizeSm='6'>
                  <IonButtons>
                    <IonButton disabled={false}
                      onClick={() => {
                        mostrarAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarItemProdutos(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        });
                      }}
                    >
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>
                  </IonButtons>
                </IonCol>

              </IonRow>
            </>
          ))}
        </IonGrid>
      </>
    );
  }

  function carregarSomasItemProdutos() {

    // Calcula a nova soma dos valores após a remoção
    const totalValor = listaItemProdutos.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  function deletarItemProdutos(index: number) {
    // Filtra a lista de produtos, removendo o item com o índice fornecido
    const itemRemovido = listaItemProdutos[index];
    const updatedList = listaItemProdutos.filter((_: any, i: any) => i !== index);

    // Atualiza a lista de produtos com o item removido
    setListaItemProdutos(updatedList);

    // Analytics: RemoveFromCart
    try { if (itemRemovido) analytics.trackRemoveFromCart(itemRemovido); } catch (e) { /* noop */ }

    // Calcula a nova soma dos valores após a remoção
    const totalValor = updatedList.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  const truncarTexto = (texto: string, limite: number) => {
    return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
  };


  async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any, taxaEntregaSelecionado: any, tempoEntregaSelecionado: any, complementoSelecionado: any) {
    console.log("enderecoSelecionado", enderecoSelecionado);
    console.log("latitudeSelecionado", latitudeSelecionado);
    console.log("enderecoLngSelecionado", enderecoLngSelecionado);
    console.log("taxaEntregaSelecionado", taxaEntregaSelecionado);
    console.log("tempoEntregaSelecionado", tempoEntregaSelecionado);
    console.log("complementoSelecionado", complementoSelecionado);

    setEndereco(enderecoSelecionado);
    localStorage.setItem("enderecoEntrega", enderecoSelecionado);
    setEnderecoLat(latitudeSelecionado);
    localStorage.setItem("latitudeEntrega", latitudeSelecionado);
    setEnderecoLng(enderecoLngSelecionado);
    localStorage.setItem("longitudeEntrega", enderecoLngSelecionado);

    setTaxaEntrega(taxaEntregaSelecionado);
    localStorage.setItem("taxaEntrega", taxaEntregaSelecionado);

    setTempoEntrega(tempoEntregaSelecionado);
    localStorage.setItem("tempoEntrega", tempoEntregaSelecionado);

    setComplemento(complementoSelecionado || "");
    localStorage.setItem("complementoEntrega", complementoSelecionado || "");

    if (Array.isArray(dadosEmpresa.configuracoesEntrega) && dadosEmpresa.configuracoesEntrega.length > 0 && enderecoSelecionado === "RETIRADA") {
      const tempos = dadosEmpresa.configuracoesEntrega?.map((c: any) => parseInt(c.tempo));
      const tempoMinimo = Math.min(...tempos);

      setTempoEntrega(tempoMinimo);
      localStorage.setItem("tempoEntrega", tempoMinimo?.toString());

    }

    setShowDetalhesEndereco(false);
  }

  async function closeModalSimpleEndereco() {
    setShowDetalhesEndereco(false);
  }

  async function closeModalAgendamentoSimple() {
    setShowModalAgendamento(false);
  }

  async function closeModalAgendamento(dataAgendamento: any, horaAgendamento: any, tipoAgendamento: any) {
    setShowModalAgendamento(false);
    setTipoAgendamento(tipoAgendamento);
    setDataAgendamento(dataAgendamento);
    setHoraAgendamento(horaAgendamento);
    localStorage.setItem("tipoAgendamento", tipoAgendamento);
    localStorage.setItem("dataAgendamento", dataAgendamento);
    localStorage.setItem("horaAgendamento", horaAgendamento);

    if (!endereco) {
      setShowDetalhesEndereco(true);
    }
  }

  async function closeModalPedidoFechar() {
    setShowPedidoFechar(false);
  }

  async function closeModalPedidoFecharSucess() {
    setShowPedidoFechar(false);
    props.closeAction();
  }

  async function closeModalDesconto() {
    setShowModalDesconto(false);
  }

  async function closeModalDescontoSucess(desconto: any, cupom: any) {

    if (desconto && cupom) {
      setDesconto(desconto);
      setCupom(cupom);
    }
    else {
      setDesconto("");
      setCupom("");
    }

    setShowModalDesconto(false);
  }

  async function closeModalCashBack() {
    setShowModalCashBack(false);
  }

  async function closeModalCashBackSucess(valorResgate: any) {
    setResgateCashBack(valorResgate);
    setShowModalCashBack(false);
  }

  async function closeModalEntrarSimple() {
    setShowModalEntrar(false);
  }

  async function closeModalEntrar(nome?: string, telefone?: string) {
    if (nome && telefone) {
      localStorage.setItem("nome", nome);
      localStorage.setItem("telefone", telefone);
    }
    setShowModalEntrar(false);
    await fazerLoginAutomatico(nome, telefone);
  }

  async function fazerLoginAutomatico(nome: string = "", telefone: string = "") {
    const nomeFinal = (nome || localStorage.getItem("nome") || "").trim();
    const telefoneFinal = (telefone || localStorage.getItem("telefone") || "").trim();

    if (!nomeFinal || !telefoneFinal) {
      setTextToast("Erro ao fazer login. Dados incompletos.");
      setShowToast(true);
      return;
    }

    setShowLoading(true);

    try {
      const body = {
        nome: nomeFinal,
        telefone: telefoneFinal,
      };

      const response = await fetch(cadastrarELogarDireto.url, {
        method: cadastrarELogarDireto.method,
        headers: {
          'Content-Type': 'application/json'
        } as HeadersInit,
        credentials: 'include',
        body: JSON.stringify(body)
      });

      const retorno = await response.json();

      if (response.status === 200 || response.status === 201) {
        console.log("Login automático realizado com sucesso:", retorno);

        // Armazena o token se retornar
        if (retorno.token) {
          localStorage.setItem("token", "token=" + retorno.token);
        }

        // Redireciona para a página Inicio
        history.replace("/cliente/inicio?abrirCarrinho=true");
      } else {
        history.replace("/novo-login");
      }
    } catch (error) {
      history.replace("/novo-login");
    } finally {
      setShowLoading(false);
    }
  }

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  // Função para formatar a data no padrão brasileiro
  function formatarData(isoDate: string): string {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar className="pedido-fluxo-modal-toolbar">
          <IonButtons slot="start" className="pedido-fluxo-back-buttons">
            <IonButton className="pedido-fluxo-back-button" fill="clear" onClick={() => props.closeActionVoltar()}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Carrinho</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>

        <div style={{ padding: '0px', color: "var(--ion-color-medium)" }}>



          <IonItem
            lines="none"
            button
            detail={true}
            hidden={!dadosEmpresa.agendamento}
            onClick={() => setShowModalAgendamento(true)}
          >



            {!tipoAgendamento ? (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="danger"
                />
                <IonLabel color="danger">Data do Pedido</IonLabel>
              </>
            ) : tipoAgendamento === "AGORA" ? (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="success"
                />
                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      AGORA
                    </b>
                  </IonLabel>
                </div>
              </>
            ) : (
              <>
                <IonIcon
                  icon={calendarOutline}
                  slot="start"
                  color="success"
                />
                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      {truncarTexto(`${formatarData(dataAgendamento)} às ${formatarHora(horaAgendamento)}`, 80)}
                    </b>
                  </IonLabel>
                </div>
              </>
            )}
          </IonItem>

          <IonItem

            lines="none"
            button
            detail={true}

            onClick={() => setShowDetalhesEndereco(true)}
          // style={{
          //   borderColor: '#dddddd', borderWidth: '1px', borderStyle: 'solid'
          // }}
          >

            {!endereco ? (
              <>

                <IonIcon
                  icon={locationOutline}
                  slot="start"
                  color="danger"
                />
                <IonLabel color="danger">Calcular taxa de entrega</IonLabel>
              </>
            ) : (
              <>
                <IonIcon
                  icon={locationOutline}
                  slot="start"
                  color="success"
                />

                <div style={{ fontSize: '12px' }}>
                  <IonLabel class="ion-text-wrap" color="success">
                    <b style={{ color: "var(--ion-color-success)" }}>
                      {truncarTexto(`${endereco}${complemento ? " / " + complemento : ""}`, 80)}
                    </b>
                  </IonLabel>
                  <IonLabel color="success" hidden={dadosEmpresa.agendamento && (tipoAgendamento == "" || tipoAgendamento == "AGENDADO")}>
                    {endereco === "RETIRADA"
                      ? tempoEntrega ? `Retirada em ${tempoEntrega} minutos` : ""
                      : `Entrega em ${tempoEntrega} minutos / R$ ${taxaEntrega}`}
                  </IonLabel>

                </div>

              </>
            )}

          </IonItem>



          <IonGrid>


            <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderBottomStyle: 'solid' }}>
              <IonCol size="12"><IonLabel><b>Itens adicionados</b></IonLabel></IonCol>
            </IonRow>

          </IonGrid>

          <div>
            <div>
              {loadItemProdutos()}
            </div>
          </div>

        </div>



        <IonModal className="fullscreen-modal"
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <Endereco endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></Endereco>
        </IonModal>

        <IonModal
          className="medium-modal"
          isOpen={showModalAgendamento}
          onDidDismiss={() => { setShowModalAgendamento(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <Agendamento closeActionSimple={closeModalAgendamentoSimple} closeAction={closeModalAgendamento}></Agendamento>
        </IonModal>


        <IonModal className="fullscreen-modal" isOpen={showPedidoFechar} onDidDismiss={() => { setShowPedidoFechar(false); }}>
          <PedidoFechar produtos={listaItemProdutos} logado={props.logado} desconto={desconto} resgateCashBack={resgateCashBack} closeAction={closeModalPedidoFecharSucess} closeActionSimple={closeModalPedidoFechar}></PedidoFechar>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalCashBack} onDidDismiss={() => { closeModalCashBack(); }}>
          <Cashback totalCashBack={totalCashBack} resgateCashBack={resgateCashBack} items={listCashBack} closeAction={closeModalCashBackSucess} closeActionSimple={closeModalCashBack}></Cashback>
        </IonModal>

        <IonModal
          className="mini-modal"
          isOpen={showModalEntrar}
          onDidDismiss={() => { setShowModalEntrar(false); }}
          style={{
            '--backdrop-opacity': '0.4',
            '--backdrop-background': 'rgba(0,0,0,0.4)'
          }}
        >
          <Entrar nome={localStorage.getItem("nome") || ""} celular={localStorage.getItem("telefone") || ""} logado={false} closeActionSimple={closeModalEntrarSimple} closeAction={closeModalEntrar}></Entrar>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalDesconto} onDidDismiss={() => { closeModalDesconto(); }}>
          <Cupom configuracoesCupom={dadosEmpresa.configuracoesCupom} cupom={cupom} valorProdutos={parseFloat(String(valorTotalProdutos || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0} valorTaxaEntrega={parseFloat(String(taxaEntrega || '0').replace(/\./g, '').replace(/\,/g, '.')) || 0} closeAction={closeModalDescontoSucess} closeActionSimple={closeModalDesconto}></Cupom>
        </IonModal>

      </IonContent>

      <IonFooter>

        <IonToolbar style={{ padding: '10px' }}>

          <div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

              {/* Resumo subtotal, desconto, taxa de serviço, total geral */}
              <IonGrid style={{ padding: "0px", margin: "0px" }}>

                <IonRow style={{ fontSize: '16px' }}>
                  <IonCol style={{}} size="5"><IonLabel><b>Subtotal</b></IonLabel></IonCol>
                  <IonCol style={{}} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotalProdutos ? "R$ " + valorTotalProdutos : "R$ 0,00"}</b></IonLabel></IonCol>

                </IonRow>

                {dadosEmpresa?.configuracoesCupom && dadosEmpresa.configuracoesCupom.length > 0 && (
                  <IonRow style={{ fontSize: '16px' }}>
                    <IonCol size="7">
                      <IonLabel>
                        <IonIcon size='small' icon={ticketOutline}></IonIcon> Cupom
                      </IonLabel>
                    </IonCol>
                    <IonCol size="5" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      {!desconto ? (
                        <IonLabel
                          color="success"
                          style={{
                            fontWeight: 'bold',
                            cursor: 'pointer',
                          }}
                          onClick={() => setShowModalDesconto(true)}
                        >
                          Adicionar
                        </IonLabel>
                      ) : (
                        <IonLabel
                          color="primary"
                          style={{
                            fontWeight: 'bold',
                            cursor: 'pointer',
                          }}
                          onClick={() => setShowModalDesconto(true)}
                        >
                          {cupom}
                        </IonLabel>
                      )}
                    </IonCol>
                  </IonRow>
                )}

                {dadosEmpresa?.cashbackAtivado && (
                  <IonRow style={{ fontSize: '16px' }}>
                    <IonCol size="7">
                      <IonLabel>
                        <IonIcon size='small' icon={syncOutline}></IonIcon> Cashback
                      </IonLabel>
                    </IonCol>
                    <IonCol size="5" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      {(!props.logado) ? (
                        <IonLabel
                          color="danger"
                          style={{ fontWeight: 'bold', cursor: 'pointer' }}
                          onClick={() => setShowModalEntrar(true)}
                        >
                          Entrar
                        </IonLabel>
                      ) : resgateCashBack <= 0 ? (
                        <IonLabel
                          color="success"
                          style={{ fontWeight: 'bold', cursor: 'pointer' }}
                          onClick={() => setShowModalCashBack(true)}
                        >
                          Adicionar
                          {/* {totalCashBack > 0 ? `R$ ${totalCashBack.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : 'Adicionar'} */}
                        </IonLabel>
                      ) : (
                        <IonLabel
                          color="primary"
                          style={{ fontWeight: 'bold', cursor: 'pointer' }}
                          onClick={() => setShowModalCashBack(true)}
                        >
                          - R$ {resgateCashBack.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                        </IonLabel>
                      )}
                    </IonCol>
                  </IonRow>
                )}



                <IonRow style={{ fontSize: '16px' }}>
                  <IonCol style={{}} size="7"><IonLabel>Taxa de entrega</IonLabel></IonCol>
                  <IonCol style={{}} size="5"><IonLabel style={{ display: 'block', textAlign: "right" }}>{taxaEntrega ? "R$ " + taxaEntrega : "R$ 0,00"}</IonLabel></IonCol>

                </IonRow>

                <IonRow style={{ fontSize: '20px' }}>
                  <IonCol style={{}} size="5"><IonLabel><b>Total</b></IonLabel></IonCol>
                  <IonCol style={{}} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotal ? "R$ " + valorTotal : "R$ 0,00"}</b></IonLabel></IonCol>

                </IonRow>

              </IonGrid>


            </div>
          </div>

          <IonButton
            // color="success"
            style={{ height: "46px", fontSize: "18px" }}
            onClick={async () => {

              console.log("listaItemProdutos", listaItemProdutos);

              // Bloqueio quando a loja está temporariamente fechada para novos pedidos.
              if (dadosEmpresa?.deliveryFechado === true) {
                setTextToast("Loja temporariamente fechada para novos pedidos. Tente novamente em alguns instantes.");
                setShowToast(true);
                return;
              }
              console.log("endereco", endereco);

              let dataReferencia = new Date();

              if (tipoAgendamento === "AGENDADO" && dataAgendamento && horaAgendamento) {
                // Se for agendado, usa a data e hora do agendamento
                const dataObj = new Date(dataAgendamento);
                const ano = dataObj.getFullYear();
                const mes = dataObj.getMonth();
                const dia = dataObj.getDate();

                let hora = 0;
                let minuto = 0;

                if (horaAgendamento.includes('T')) {
                  // Extrair HH:mm diretamente da string ISO para evitar conversão de fuso horário
                  // O IonDatetime retorna algo como "2025-12-03T22:30:00" (às vezes com Z, às vezes sem)
                  // Queremos apenas os números visuais
                  const timePart = horaAgendamento.split('T')[1];
                  const [h, m] = timePart.split(':');
                  hora = parseInt(h);
                  minuto = parseInt(m);
                } else {
                  const [h, m] = horaAgendamento.split(':').map(Number);
                  hora = h;
                  minuto = m;
                }

                dataReferencia = new Date(ano, mes, dia, hora, minuto);

                // Validar se a data/hora não é no passado
                const agora = new Date();
                agora.setSeconds(0);
                agora.setMilliseconds(0);

                console.log("Data String:", dataAgendamento);
                console.log("Data Local Interpretada:", dataReferencia);
                console.log("Agora:", agora);

                if (dataReferencia < agora) {
                  setTextToast("A data de agendamento deve ser futura.");
                  setShowToast(true);
                  return;
                }
              }

              const diaAtual = dataReferencia.getDay(); // 0 a 6
              const horarioAtual = dataReferencia.getHours() * 60 + dataReferencia.getMinutes(); // em minutos

              const diasSemanaNumber: any = {
                SUNDAY: 0,
                MONDAY: 1,
                TUESDAY: 2,
                WEDNESDAY: 3,
                THURSDAY: 4,
                FRIDAY: 5,
                SATURDAY: 6,
              };

              const diaAtualTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAtual
              );
              const diaAmanha = (diaAtual + 1) % 7;
              const amanhaTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAmanha
              );

              if (dadosEmpresa.horarios) {
                const horariosHoje = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === diaAtualTexto
                ) || [];

                const horariosAmanha = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === amanhaTexto
                ) || [];

                let estaDentroDoHorario = false;
                let proximoHorarioHoje: any = null;

                for (const horario of horariosHoje.sort((a: any, b: any) => a.start.localeCompare(b.start))) {
                  const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
                  const inicio = horaInicio * 60 + minutoInicio;
                  const fim = inicio + horario.duration;

                  if (horarioAtual >= inicio && horarioAtual <= fim) {
                    estaDentroDoHorario = true;
                    break;
                  }

                  if (horarioAtual < inicio && !proximoHorarioHoje) {
                    proximoHorarioHoje = horario;
                  }
                }

                const valorTotalProdutosNumerico = parseFloat(
                  valorTotalProdutos?.replace(/\./g, "").replace(/\,/g, ".")
                );
                const pedidoMinimoNumerico = parseFloat(
                  dadosEmpresa.pedidoMinimo?.replace(/\./g, "").replace(/\,/g, ".")
                );

                if (listaItemProdutos?.length === 0) {
                  setTextToast("Selecione pelo menos um produto.");
                  setShowToast(true);
                } else if (valorTotalProdutosNumerico < pedidoMinimoNumerico) {
                  setTextToast(
                    "Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos."
                  );
                  setShowToast(true);

                } else if (dadosEmpresa.agendamento && !tipoAgendamento) {
                  setShowModalAgendamento(true);
                }
                else if (!endereco) {
                  setShowDetalhesEndereco(true);
                }
                else if (!estaDentroDoHorario) {

                  if (tipoAgendamento === "AGENDADO") {
                    setTextToast("O estabelecimento estará fechado no horário agendado. Por favor, escolha outro horário.");
                  } else {
                    // Lógica para quando é "AGORA"
                    if (proximoHorarioHoje) {
                      setTextToast(
                        `Não é possível realizar o pedido agora. Abrimos hoje às ${formatarHorario(
                          proximoHorarioHoje.start
                        )}.`
                      );
                    } else if (horariosAmanha.length > 0) {
                      const proximoHorarioAmanha = horariosAmanha.sort((a: any, b: any) =>
                        a.start.localeCompare(b.start)
                      )[0];
                      setTextToast(
                        `Estamos fechados. Abrimos amanhã às ${formatarHorario(
                          proximoHorarioAmanha.start
                        )}.`
                      );
                    } else {
                      setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                    }
                  }
                  setShowToast(true);
                } else {
                  console.log("listaItemProdutos", listaItemProdutos);
                  console.log("props.logado", props.logado);

                  if (
                    desconto &&
                    Array.isArray(dadosEmpresa.configuracoesCupom)

                  ) {

                    const cupomSelecionado = dadosEmpresa.configuracoesCupom.find((configCupom: any) => configCupom.nome === cupom);

                    console.log("valorTotalProdutosNumerico", valorTotalProdutosNumerico);
                    console.log("cupomSelecionado", cupomSelecionado);

                    if (cupomSelecionado && cupomSelecionado.valorMinimo) {

                      let cupomSelecionadoFloat = parseFloat(cupomSelecionado.valorMinimo?.replace(/\./g, '').replace(/\,/g, '.'));

                      if (valorTotalProdutosNumerico < cupomSelecionadoFloat) {

                        setTextToast("Não é possível realizar o pedido com esse cupom devido o valor mínimo de R$ " + cupomSelecionado.valorMinimo + " em produtos.");
                        setShowToast(true);
                        return;
                      }
                    }

                  }

                  // Validação de estoque antes de avançar para o checkout
                  // Usa catalogoProdutos como fonte autoritativa (mesmo que o back),
                  // pois complementos no carrinho podem não carregar controlarEstoque.
                  const catalogoProdutosContinuar: any[] = dadosEmpresa?.catalogoProdutos || [];

                  const demandaTotalPorId: Record<string, number> = {};
                  (listaItemProdutos || []).forEach((cartItem: any) => {
                    const cartQtd = parseFloat(
                      (cartItem.quantidade || '0').toString().replace(/\./g, '').replace(/,/g, '.')
                    ) || 0;
                    if (Array.isArray(cartItem.descricao)) {
                      cartItem.descricao.forEach((sub: any) => {
                        if (!sub.id) return;
                        const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === sub.id);
                        if (catalogItem && catalogItem.controlarEstoque) {
                          const m = String(sub.descricao || '').match(/^(\d+)x\s/);
                          const sq = m ? parseInt(m[1], 10) : 1;
                          demandaTotalPorId[sub.id] = (demandaTotalPorId[sub.id] || 0) + sq * cartQtd;
                        }
                      });
                    } else if (cartItem.id) {
                      const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === cartItem.id);
                      if (catalogItem && catalogItem.controlarEstoque) {
                        demandaTotalPorId[cartItem.id] = (demandaTotalPorId[cartItem.id] || 0) + cartQtd;
                      }
                    }
                  });

                  let estoqueExcedidoContinuar = false;
                  let msgEstoqueContinuar = '';
                  for (const [itemId, totalDemandado] of Object.entries(demandaTotalPorId)) {
                    const catalogItem = catalogoProdutosContinuar.find((c: any) => c.id === itemId);
                    if (catalogItem && catalogItem.controlarEstoque) {
                      const estoqueAtual = Number(catalogItem.quantidadeEstoque) || 0;
                      if (totalDemandado > estoqueAtual) {
                        estoqueExcedidoContinuar = true;
                        const nome = catalogItem.nome || catalogItem.descricao || itemId;
                        msgEstoqueContinuar = `O item "${nome}" possui apenas ${estoqueAtual} unidade(s) disponível(eis) e o pedido solicita ${totalDemandado}.`;
                        break;
                      }
                    }
                  }

                  if (estoqueExcedidoContinuar) {
                    setTextToast(msgEstoqueContinuar);
                    setShowToast(true);
                    return;
                  }

                  // Caso queira colocar um parametro por empresa
                  // if (props.logado) {

                  setDesconto(desconto);
                  // Analytics: InitiateCheckout
                  try {
                    const totalNum = parseFloat(String(valorTotalProdutos || 0).replace(/\./g, '').replace(/\,/g, '.')) || 0;
                    analytics.trackInitiateCheckout(listaItemProdutos, totalNum);
                  } catch (e) { /* noop */ }
                  setShowPedidoFechar(true);

                  // }
                  // else {
                  //   props.closeAction();
                  //   history.push("/novo-login");
                  // }
                }
              }
              else {
                setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                setShowToast(true);
              }



            }}
            expand="block"
            type="submit"
          >
            Continuar
          </IonButton>



        </IonToolbar>
      </IonFooter >

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ logado, closeAction, closeActionVoltar }: { logado: any, closeAction: Function, closeActionVoltar: Function }) => (
  <Carrinho logado={logado} closeAction={closeAction} closeActionVoltar={closeActionVoltar} >
  </Carrinho>
)
